export const PAYMENT_METHOD = {
  PAC: 'PAC',
  PAD: 'PAD',
  REGULAR: 'REGULAR'
}

export const PAP_MESSAGE_TYPE = {
  PAP_PROMOTING_NEW_CUSTOMER_BUYING_MNH: 'papPromoting.newCustomerBuyingMnH',
  PAP_PROMOTING_NEW_CUSTOMER_BUYING_MOBILITY: 'papPromoting.newCustomerBuyingMobility',
  PAP_PROMOTING_NEW_CUSTOMER_BUYING_HS: 'papPromoting.newCustomerBuyingHS',
  PAP_PROMOTING_EXISTING_CUSTOMER_WITH_PAD: 'papPromoting.existingCustomerWithPAD',
  PAP_PROMOTING_EXISTING_CUSTOMER_WITH_PAC: 'papPromoting.existingCustomerWithPAC',
  PAP_PROMOTING_EXISTING_CUSTOMER_WITHOUT_PAP: 'papPromoting.existingCustomerWithoutPAP',
  PAP_PROMOTING_EXISTING_CUSTOMER_BUYING_CROSSLINE: 'papPromoting.existingCustomerBuyingCrossLine',
  PAD_PROMOTING_NEW_CUSTOMER_BUYING_MNH: 'padPromoting.newCustomerBuyingMnH',
  PAD_PROMOTING_NEW_CUSTOMER_BUYING_MOBILITY: 'padPromoting.newCustomerBuyingMobility',
  PAD_PROMOTING_NEW_CUSTOMER_BUYING_HS: 'padPromoting.newCustomerBuyingHS',
  PAD_PROMOTING_EXISTING_CUSTOMER_WITH_PAD: 'padPromoting.existingCustomerWithPAD',
  PAD_PROMOTING_EXISTING_CUSTOMER_WITH_PAC: 'padPromoting.existingCustomerWithPAC',
  PAD_PROMOTING_EXISTING_CUSTOMER_WITHOUT_PAP: 'padPromoting.existingCustomerWithoutPAP',
  PAD_PROMOTING_EXISTING_CUSTOMER_BUYING_CROSSLINE: 'padPromoting.existingCustomerBuyingCrossLine'
}
